import { useQuery } from '@tanstack/react-query';

import { getUploadedFile, getUploadedFilePresignedUrl } from 'admin/resources';
import { storyKeys } from '../queryKeys';

export interface FileData {
	storyUpload: {
		key: string;
		storyId: string;
		organizationId: string;
		scanStatus: string;
		isDeleted: boolean;
		sizeInBytes: number;
		createdAt: string;
		updatedAt: string;
	};
}

export interface FilePresignedUrl {
	url: string;
}

/** Get File Data */
const getUploadedFileDataQueryFn = async (fileKey: string) => {
	const response: ApiV2Response<FileData> = await getUploadedFile.params({ fileKey }).send({});
	return response.body;
};

export const useGetUploadedFile = (fileKey: string, options?: { enabled: boolean }) => {
	return useQuery({
		queryKey: storyKeys.uploadedFile.detail(fileKey),
		queryFn: () => getUploadedFileDataQueryFn(fileKey),
		enabled: options?.enabled,
		staleTime: 30 * 1000, // 30 seconds
	});
};

/** Get Presigned Url for Download */
const getUploadedFilePresignedUrlQueryFn = async (fileKey: string) => {
	const response: ApiV2Response<FilePresignedUrl> = await getUploadedFilePresignedUrl.params({ fileKey }).send({});
	return response.body;
};

export const useGetUploadedFilePresignedUrl = (fileKey: string) => {
	return useQuery({
		queryKey: storyKeys.getUploadedFilePresignedUrl.detail(fileKey),
		queryFn: () => getUploadedFilePresignedUrlQueryFn(fileKey),
		enabled: false,
		staleTime: 0, // Always fetch fresh presigned URLs
	});
};
